import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../lib/api";

const AboutPage = () => {
  const settingsQuery = useQuery({
    queryKey: ["site-settings"],
    queryFn: () => apiClient.frontend.GetSiteSettings(),
  });

  const aboutText = settingsQuery.data?.AboutText ?? "";

  return (
    <section className="max-w-2xl mx-auto px-6 md:px-8 py-16 text-center">
      <h2 className="font-display text-2xl uppercase-track mb-10">
        About the Artist
      </h2>
      <img
        src={settingsQuery.data?.AboutImageURL || "/artist.jpg"}
        alt="Kinsey Jones"
        className="mx-auto mb-10 w-full max-w-xs aspect-[4/5] object-cover"
      />
      <p className="text-sm text-[var(--color-kj-text-light)] leading-loose whitespace-pre-wrap">
        {aboutText}
      </p>
    </section>
  );
};

export default AboutPage;
